module.exports = __webpack_public_path__ + "img/lb-aitxt.162d72fd.png";